import { ReactNode } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ModalName, useModal } from 'modules/modal';
import {
  ContactContentBlock,
  ContactIconWrapper,
  ContactTitle,
  ContactTitleBlock
} from './styledComponents';

interface Props {
  title: string;
  children: ReactNode;
  textToCopy: string;
}
export const ContactContentBlockView = ({
  title,
  children,
  textToCopy
}: Props) => {
  const { open } = useModal();

  const copyTextToClipboard = async (text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      open(ModalName.copyTextSuccessToast);
    } catch (err) {
      /* empty */
    }
  };

  return (
    <ContactContentBlock>
      <ContactTitleBlock>
        <ContactTitle variant="h6">{title}</ContactTitle>
        <ContactIconWrapper
          data-testid="content-copy-icon-wrapper"
          onClick={() => copyTextToClipboard(textToCopy)}
        >
          <ContentCopyIcon />
        </ContactIconWrapper>
      </ContactTitleBlock>
      {children}
    </ContactContentBlock>
  );
};
